import { prepareParams } from '@/utils/query'
import { getDeviceId } from '@/utils/device-id'
import type { InternalAxiosRequestConfig } from 'axios'
import { useAuthStore } from '@/stores/auth'

export function prepareConfigInterceptor(config: InternalAxiosRequestConfig) {
  if (config.params) {
    config.params = prepareParams(config.params)
  }

  config.headers = config.headers || {}
  config.headers['X-Device-Id'] = getDeviceId()

  // Add auth token
  const authStore = useAuthStore()
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`
  }

  return config
}
